import { React, useState } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import RuleRoundedIcon from '@mui/icons-material/RuleRounded';
import SwapHorizRoundedIcon from '@mui/icons-material/SwapHorizRounded';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';

const TrocaAgencia = () => {
    const [ccs, setCCs] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitTrocaAgencia (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({ ccs });

        try {
            const response = await fetchFlask('trocaAgencia', body);
            handleAlerta(response);
            if (response.status === 'success') {
                setCCs('');
            }
        } finally {
            setIsSubmit(false);
        }
    };

    function handleAlerta (response) {
        setMessage(response.message);
        setStatus(response.status);
        setOpenAlerta(true);
    }

    const ccsList = ccs
        .split(/[\s,;]+/)
        .map((cc) => cc.trim())
        .filter(Boolean);
    const completedFields = [ccsList.length > 0].filter(Boolean).length;

    return (
        <Box className='mainBox ui-workflow-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>Troca Agência</PageHeader>

            <form action='' method='POST' id='formTrocaAgencia' onSubmit={submitTrocaAgencia} className='ui-workflow-layout'>
                <Box className='ui-workflow-workspace'>
                    <Box className='ui-workflow-intro'>
                        <Box>
                            <h2>Troca de titularidade para o consórcio</h2>
                        </Box>
                    </Box>

                    <Box className='ui-workflow-panel'>
                        <Box className='ui-heading'>
                            <Inventory2RoundedIcon />
                            <Box>
                                <span>Etapa única</span>
                                <strong>Contas contrato para troca de titularidade</strong>
                            </Box>
                        </Box>

                        <Box className='ui-input-strip'>
                            <SwapHorizRoundedIcon />
                            <TextField
                                label='Contas contrato'
                                id='ccs'
                                required
                                multiline
                                minRows={7}
                                maxRows={14}
                                value={ccs}
                                onChange={(e) => setCCs(e.target.value)}
                                placeholder='Uma CC por linha, ou separadas por vírgula'
                            />
                        </Box>
                    </Box>
                </Box>

                <Box className='ui-workflow-summary'>
                    <Box className='ui-heading ui-heading-divided'>
                        <FactCheckRoundedIcon />
                        <Box>
                            <span>Resumo</span>
                            <strong>Revisão da troca</strong>
                        </Box>
                    </Box>

                    <Box className='ui-workflow-summary-list'>
                        <Box>
                            <span>Contas contrato</span>
                            <strong className={ccsList.length === 0 ? 'is-empty' : undefined}>
                                {ccsList.length === 0 ? 'Não informadas' : `${ccsList.length} identificada${ccsList.length === 1 ? '' : 's'}`}
                            </strong>
                        </Box>
                        <Box>
                            <span>Destino da titularidade</span>
                            <strong>Consórcio</strong>
                        </Box>
                        <Box>
                            <span>Canal</span>
                            <strong>Agência virtual Neoenergia</strong>
                        </Box>
                    </Box>

                    <Box className='ui-attention'>
                        <RuleRoundedIcon />
                        <p>
                            Revise a lista antes de iniciar a troca de titularidade das unidades para o consórcio.
                        </p>
                    </Box>

                    <Box className='ui-attention is-ok ui-completion'>
                        <AssignmentTurnedInRoundedIcon />
                        <Box>
                            <span>Campos críticos</span>
                            <strong>{completedFields}/1 preenchido</strong>
                        </Box>
                    </Box>

                    <SubmitButton isSubmit={isSubmit} startIcon={<AutorenewRoundedIcon />}>
                        Trocar Titularidade
                    </SubmitButton>
                </Box>
            </form>
        </Box>
    );
};

export default TrocaAgencia;
